import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getRequestProfilePathname } from '../../../utils/link'
import { RequestTag } from '../../Request'

import * as styles from './ChatroomMessageLinkedRequests.module.css'

function ChatroomMessageLinkedRequests({ linkedRequests }) {
  const { handleClick } = useLinkLikeClick()

  const { availableSections } = useInitData()

  function handleClickRequest(id, event) {
    handleClick({
      event,
      link: getRequestProfilePathname({ availableSections, id }),
      outsideLink: true,
    })
  }

  return linkedRequests?.length > 0 ? (
    <div className={styles.chatroomMessageLinkedRequests}>
      {linkedRequests.map(request => (
        <RequestTag
          {...request}
          className={styles.tag}
          key={request.id}
          onClick={handleClickRequest}
        />
      ))}
    </div>
  ) : null
}

export default ChatroomMessageLinkedRequests
